"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eye = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Eye({ size = 20 }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 19.86 13.57" },
        react_1.default.createElement(react_native_svg_1.Path, { d: "M.5 6.79S3.93.5 9.93.5s9.43 6.29 9.43 6.29-3.43 6.28-9.43 6.28S.5 6.79.5 6.79z", fill: "none", stroke: "#3db384" }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M9.93 3.21a3.58 3.58 0 11-3.57 3.58 3.58 3.58 0 013.57-3.58m0-1a4.58 4.58 0 104.57 4.58 4.57 4.57 0 00-4.57-4.58z", fill: "#3db384" })));
}
exports.Eye = Eye;
